// extracted by mini-css-extract-plugin
module.exports = {"fav-container":"classes_fav-container__bUWVW","fav-checkbox":"classes_fav-checkbox__20dzJ"};